module.exports = __webpack_public_path__ + "img/ajaccio-logo-icon.2b575b98.png";